<template>
    <div class="menu-content">
        <div class="distance-box">
            <i class="el-icon-place"></i>
            <span>Distance Covered: {{ info.deliveryDistance.replace('mi', 'Miles') }}</span>
            <span style="flex:1;" ></span>
            <!-- <span>£2 delivery fee</span> -->
        </div>
        <div class="menu-title">
            <h2>Menu</h2>
        </div>
        <div v-for="item in categoryList" :key="item.catId" class="cate-box">
            <h2>{{ item.categoryName }}</h2>
            <div class="desc">
                {{ item.categoryDescription }}
                Te ferri iisque aliquando pro, posse nonumes efficiantur in cum. Sensibus reprimique eu pro.
                Fuisset mentitum deleniti sit ea.
            </div>
            <div class="food-header food-item">
                <div class="item-name">Item</div>
                <div class="item-price"> Price</div>
                <div class="item-order" > Order </div>
            </div>
            <section class="food-box">
                <div class="food-item" v-for="food in foodList" :key="food.itemId">
                    <div class="item-name">
                        <div class="food-img" v-if="food.photo" >
                            <img v-if="food.photo" :src="food.photo" alt="">
                        </div>
                        <div>
                            <span class="name">{{ food.itemName }}</span> <br />
                            <span class="desc">{{ food.itemDescription }}</span>
                        </div>
                    </div>
                    <div class="item-price"> {{currencySign}}{{ food.price }} </div>
                    <div class="item-order" > 
                        <div class="add-btn" @click="addCart(food)">
                            <i class="el-icon-plus"></i>
                            <span>Add</span>
                        </div>    
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            default: () => {
                return {
                    deliveryDistance: ''
                }
            }
        },
        currencySign: {
            type: String,
             default: () => '￡'
        },
        categoryList: {
            type: Array,
            default: () => []
        },
        foodList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        addCart(food) {
            this.$emit('addCart'  ,food)
        }
    }
}
</script>
<style lang="scss" scoped>
    .menu-content {
        padding: 10px 20px 20px;
        min-height: 100vh;

        .distance-box {
            height: 40px;
            display: flex;
            align-items: flex-end;
            font-size: 15px;
            font-weight: 600;
            padding: 0 10px;
            i {
                font-size: 24px;
                margin-right: 5px;
                font-weight: bold;
                color: #000!important;
            }
        }
        .menu-title {
            position: sticky;
            padding-top: 10px;
            background-color: #fff;
            top: 0px;
            h2 {
                font-weight: 700;
                color: #fff;
                font-size: 25px;
                padding: 10px 20px 10px;
                margin: 0;
                background-color: #09CA6A;
                border-radius: 6px;
                box-shadow: 0px 4px 6px #8F9698;
            }
        }
        .cate-box {
            padding: 10px 20px 20px;
            border-radius: 8px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
            margin-top: 20px;
            h2 {
                font-weight: bold;
                font-size: 24px;
                color: #000;
                margin: 0;
            }
            .desc {
                font-size: 15px;
                color: #0A191E;
                padding: 10px 0 10px;
            }
        }
        .food-item {
            background-color: #fff;
            display: flex;
            border-bottom: 0.5px solid #00000033;
            padding: 15px 0;
            align-items: center;

            &:hover {
                background-color: #f7f5f5;
            }

            .item-name {
                flex: 1;
                display: flex;
                word-break: break-all;
                padding-left: 10px;
                .food-img {
                    height: 60px;
                    width: 60px;
                    min-width: 60px;
                    border-radius: 6px;
                    background-color: #e9e9e9;
                    overflow: hidden;
                    margin-right: 10px;
                }
                img {
                    height: 60px;
                    width: 60px;
                }
                .name {
                    font-size: 15px;
                    color: #000;
                    font-weight: bold;
                }
                .desc {
                    font-size: 13px;
                }
            }
            .item-price {
                padding-left: 10px;
                min-width: 60px;
                width: 20%;
                text-align: left;
                font-weight: 600;
            }
            .item-order {
                width: 20%;
                min-width: 100px;
                text-align: center;

                .add-btn {
                    width: 90px;
                    height: 32px;
                    border: 1px solid #9A47EE;
                    border-radius: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: #9A47EE;
                    font-weight: 700;
                    padding: 0 14px;
                    cursor: pointer;
                    transition: all ease-in .2s;

                    i {
                        color: #9A47EE;
                        margin-right: 2px;
                        font-weight: 700;
                        font-size: 12px;
                        margin-right: 4px;
                    }

                    &:hover {
                        background-color: #9A47EE;
                        border: 1px solid #fff;
                        color: #fff;
                        i {
                            color: #fff;
                        }
                    }
                }

            } 
        }
        .food-header{
            font-weight: bold;
            color: #000;
            border-top: 0.5px solid #00000033;
            padding: 20px 0;
            background-color: #f7f5f5;
            .item-price {
                padding-left: 0;
                text-align: left;
                font-weight: 600;
                padding-left: 10px;
            }
            .item-order {
                padding-right: 20px;
            }
        }
    }

</style>